import {View,map} from "vritra";
import css from "./PluginPreview.module.css";
import {vritrawebviewillustration0,webviewpreview0,modalpreview0} from "Assets";


export default function PluginPreview(props){
    const {parent}=props;
    const pluginpreview=View({parent,className:css.pluginpreview});

    pluginpreview.innateHTML=`
        ${map([
            {title:"modal",src:modalpreview0},
            {title:"webView",src:webviewpreview0},
        ],({title,src},i)=>`
            <div class="${css.section}" style="order:${i||2}">
                <h3 class="${css.title}">${title}</h3>
                <img alt="" src="${src}"/>
            </div>
        `)}
        <img src="${vritrawebviewillustration0}"/>
    `;

    return pluginpreview;
}
